import styled from 'styled-components'

export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    z-index: 10002;
    background-color: #353535;
    padding: 20px 8px;
`
export const ModalButton = styled.button`
    height: 36px;
    width: 60px;
    text-align: center;
    font: normal bold 13px 'Roboto Condensed';
    text-transform: uppercase;
    background-color: #fff;
    border: 2px solid #000;
    border-radius: 10px;
    margin-top: 8px;
    cursor: pointer;

    :hover {
        background-color: #000;
        color: #fff
    }
`

export const ModalRow = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    div.modal-left {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 35%;
        max-width: 480px;
        // background-color: #444;
    }
    div.modal-right {
        display: flex;
        flex-direction: column;
        align-items: center;
        min-width: 62.5%;
        max-width: calc(100% - 480px);
        height: 100%;
        // background-color: #777;
    }
`

export const AssetItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0.5em 1em;
    width: 210px;
    padding: 5px;
    border: ${props => props.border ? '1px solid #555' : 'none'};
    border-radius: 2px;

    &>div:first-child {
        width: 200px;
        height: auto
    }

    img {
        height: 80px;
        // width: 240px;

        :hover {transform: scale(1);}
    }

    p.col-asset-name {
        font: normal bold 13px 'Roboto Condensed';
        color: #fff !important;
        margin-top: .5em;
    }
    // button.add-vimeo { padding: .25em 2em;
    //     margin-top: .125em;}
`
export const VideosContainer = styled.div`
    display: flex;
    flex-flow: row wrap;
    height: 540px;
    overflow-y: scroll;
    align-content: flex-start;
    width: 90%;

    img{
        max-width: 100px;
        height: 60px;
        padding: 4px;
    }
`




// WEBPACK FOOTER //
// ./src/components/Admin/LessonBuilder/EditModal/Modal.styles.js